module.exports = __webpack_public_path__ + "dimer/static/img/project2.81cc6e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project2.jpg
// module id = oc7L
// module chunks = 0